export function getThumbnailUploadId(uploadId: string) {
  return `${uploadId}-thumbnail`
}
